import React, {useState} from 'react';
import classnames from 'classnames/bind';
import _ from 'lodash';
import style from './index.module.scss';
import publicImage from '../../utils/publicImage';
import {flatError, valEmpty, valPattern} from '../../utils/validate';
import {EMAIL_PATTERN} from '../../constants';
import {postContact} from '../../services';
import {IState, ITWorkshop, Replacement} from '../../interface';
import {connect} from 'react-redux';
import localesReplacement from '../../utils/localesReplacement';

const cx = classnames.bind(style);
const classFormControl = 'form-control'; 

export interface IProps {
  dismiss: () => void;
  replacements: Replacement;
  selected: ITWorkshop | undefined;
}

interface Form {
  name?: string;
  email?: string;
  contactNumber?: string;
  message?: string;
  promotionalCode?: string;
  signUpForCastrolPromotions?: boolean;
}

interface Error {
  name?: boolean;
  email?: boolean;
  contactNumber?: boolean;
  message?: boolean;
}

/* eslint-disable */
export const Contact = (props: IProps) => {
  const {dismiss, replacements, selected} = props;
  const [form, setForm] = useState<Form>({
    name: '',
    email: '',
    contactNumber: '',
    message: '',
    promotionalCode: '',
    signUpForCastrolPromotions: false,
  });
  const [errors, setErrors] = useState<Error>();
  const onSubmit = () => {
    const error = _.assign(
      valEmpty(_.omit(form, 'promotionalCode', 'signUpForCastrolPromotions')),
      valPattern(form.email, 'email')(EMAIL_PATTERN),
    );
    setErrors(error);
    if (flatError(error)) {
      if (selected) {
        postContact(selected.id, form);
        dismiss();
      }
    }
  };
  const onBlur = () => {
    setErrors({});
  };
  return (
    <div className={cx('content')}>
      <span
        className={`button ${cx('close')}`}
        role='button'
        onClick={dismiss}
      ></span>
      <div className={cx('container')}>
        <div className={cx('banner')}>
          <img src={publicImage('contact-banner.jpg')} alt='Banner' />
          <div className={cx('infor')}>
            <h2 title={selected?.name}>{selected?.name}</h2>
            {(_.isEqual(selected?.locationTypes[0].name, 'CPLE') ||
              _.isEqual(selected?.locationTypes[0].name, 'CAS') ||
              _.isEqual(selected?.locationTypes[0].name, 'CS')) && (
              <div className={cx('badge')}>
                {localesReplacement(replacements, 'Castrol RECOMMENDATION')}
              </div>
            )}
          </div>
        </div>
        <div className={cx('form')}>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'NAME')}
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.name, false),
                })}
              >
                <input
                  value={form?.name}
                  onChange={(e) => setForm({...form, name: e.target.value})}
                  onFocus={onBlur}
                />
              </div>
            </label>
          </div>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'EMAIL')}
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.email, false),
                })}
              >
                <input
                  value={form?.email}
                  onChange={(e) => setForm({...form, email: e.target.value})}
                  onFocus={onBlur}
                />
              </div>
            </label>
          </div>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'CONTACT NUMBER')}
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.contactNumber, false),
                })}
              >
                <input
                  value={form?.contactNumber}
                  onChange={(e) =>
                    setForm({...form, contactNumber: e.target.value})
                  }
                  onFocus={onBlur}
                />
              </div>
            </label>
          </div>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'MESSAGE')}
              <div
                className={cx(classFormControl, {
                  error: _.isEqual(errors?.message, false),
                })}
              >
                <textarea
                  value={form?.message}
                  onChange={(e) => setForm({...form, message: e.target.value})}
                  onFocus={onBlur}
                />
              </div>
            </label>
          </div>
          <div className={cx('row')}>
            <label>
              {localesReplacement(replacements, 'PROMOTIONAL CODE')}{' '}
              <small>
                ({localesReplacement(replacements, 'if applicable')})
              </small>
              <div className={cx(classFormControl, 'small-form-control')}>
                <input
                  value={form?.promotionalCode}
                  onChange={(e) =>
                    setForm({...form, promotionalCode: e.target.value})
                  }
                />
              </div>
            </label>
          </div>
          <div className={cx('footer')}>
            <button
              className={`primary-button ${cx('button')}`}
              onClick={onSubmit}
            >
              {localesReplacement(replacements, 'Send Message')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

export default connect(mapStateToProps)(Contact);
